import { render, staticRenderFns } from "./veStuAssocInfoAp.vue?vue&type=template&id=56a61a06&scoped=true"
import script from "./veStuAssocInfoAp.vue?vue&type=script&lang=js"
export * from "./veStuAssocInfoAp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a61a06",
  null
  
)

export default component.exports